<div class="container"><div class="container">

  <div *ngIf="currentUser" class="row mb-40">
      <div class="col-md-6">
          <h2>{{ 'settings.account.title' | translate }}</h2>
          <p class="lead mb-4 text-muted">{{ 'settings.account.subtitle' | translate }}</p>

            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ 'settings.account.card.title' | translate }}</h5>
                  <div class="card-text">

                    <form class="form-horizontal" [formGroup]="form" (ngSubmit)="onSubmit()">

                      <div class="form-group">
                          <label for="oldPassword" class="control-label">{{ 'settings.account.card.oldpassword' | translate }}</label>
                          <input type="password" id="oldPassword" class="form-control" formControlName="oldPassword">
                      </div>

                      <div class="form-group">
                          <label for="newPassword" class="control-label">{{ 'settings.account.card.newpassword' | translate }}</label>
                          <input type="password" id="newPassword" class="form-control" formControlName="newPassword"
                                 [ngClass]="{ 'is-invalid': form.get('newPassword').touched && form.get('newPassword').errors }">
                          <div *ngIf="form.get('newPassword').touched && form.get('newPassword').errors" class="invalid-feedback">
                              <div *ngIf="form.get('newPassword').errors.required">New password is required</div>
                              <div *ngIf="form.get('newPassword').errors.strongPassword">
                                  Password does not meet complexity requirements
                              </div>
                          </div>
                          <!-- Password strength indicator -->
                          <app-password-strength [password]="form.get('newPassword').value" [showRequirements]="true"></app-password-strength>
                      </div>

                      <div class="form-group">
                          <label for="newPasswordConfirm" class="control-label">{{ 'settings.account.card.confirmpassword' | translate }}</label>
                          <input type="password" id="newPasswordConfirm" class="form-control" formControlName="newPasswordConfirm"
                                 [ngClass]="{ 'is-invalid': form.get('newPasswordConfirm').touched && form.get('newPasswordConfirm').errors }">
                          <div *ngIf="form.get('newPasswordConfirm').touched && form.get('newPasswordConfirm').errors" class="invalid-feedback">
                              <div *ngIf="form.get('newPasswordConfirm').errors.required">Please confirm your password</div>
                              <div *ngIf="form.get('newPasswordConfirm').errors.matchOther">Passwords do not match</div>
                          </div>
                      </div>

                      <div class="form-group">
                          <button type="submit" [disabled]="!form.valid || loading" class="btn btn-primary">{{ 'settings.account.card.button' | translate }}</button>
                          <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      </div>
                      <div *ngIf="error" class="alert alert-danger">{{error}}</div>
                    </form>
                                
                  </div>
              </div>
            </div>

      </div>
  </div>

  <div class="row">
    <div class="col-12">
      <h2>{{ 'settings.main.title' | translate }}</h2>
      <p class="lead mb-4 text-muted">{{ 'settings.main.subtitle' | translate }}</p>
    </div>
  </div>
  <div class="row m-b-20">
    <div class="col-12 col-sm-6 m-b-20">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ 'settings.main.gps.subtitle' | translate }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ 'settings.main.gps.subtitle' | translate }}</h6>
          <p class="card-text">
          	<span style="padding-right: 20px;">{{ 'settings.main.gps.latitude' | translate }}: {{ this.latitude }}</span><span>{{ 'settings.main.gps.longitude' | translate }}: {{ this.longitude }}</span>
          </p>
          <p class="card-text">
            <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
              <agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>
            </agm-map>
          </p>
          <p class="card-text">
            {{ 'settings.main.gps.text' | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 m-b-20">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ 'settings.main.connection.title' | translate }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ this.ispName }}</h6><br>
          <div *ngIf="!didLoad">
            <div class="spinner secondary-yellow-bgr"></div>
          </div>
          <div *ngIf="didLoad">
            <div class="card-text">
              IPv4: <span class="">{{ this.ipv4 }}</span><br>
              IPv6: <span class="">{{ this.ipv6 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
</div>